import { css } from "emotion";

const ButtonRow = ({ justify = "center", children }) => {
  return (
    <div style={{ textAlign: justify }}>
      {children.map(child => {
        return (
          <div
            style={{
              margin: "0 4px",
              display: "inline-block",
              verticalAlign: "top"
            }}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
};
export default ButtonRow;



// WEBPACK FOOTER //
// ./components/ButtonRow.js